<template>
	<!--Beginning of profile sheet-->
	<v-sheet class="overflow-auto pb-10"
		v-if="$vuetify.breakpoint.mdAndUp" 
		:width="profilePageWidth" :height="profilePageHeight"
		>
		<div class="container pb-10 overflow-auto" v-if="$vuetify.breakpoint.mdAndUp" 
		:width="profilePageWidth" :height="profilePageHeight">
			<section class="section1">
				<v-card class="pa-4" outlined>
					<!-- Top row: avatar, name/description, follow button -->
					<v-row align="start" no-gutters>
					<!-- Avatar -->
					<v-col cols="auto">
						<v-avatar size="130">
							<v-img v-if="!profileData?.profile.profile_image">
								<v-icon>mdi-camera</v-icon>
							</v-img>
							<v-img v-else :src="profileData?.profile.profile_image" alt="avatar" @click="imgDialog = true"/>
							<v-dialog 
								:fullscreen="$vuetify.breakpoint.smAndDown"
								:width="$vuetify.breakpoint.mdAndUp ? 800 : '100%'"
								:height="$vuetify.breakpoint.mdAndUp ? 400 : 'mx-auto'" 
								transition="fade-transition"
								v-model="imgDialog" persistent>
								<v-card>
									<v-img  
										:lazy-src="profileData?.profile.profile_image" :src="profileData?.profile.profile_image">
										<v-btn elevation="0" fab x-small outlined color="white" class="close-button float-right" @click="imgDialog = false">
											<v-icon color="white">mdi-close</v-icon>
										</v-btn>
									</v-img>
								</v-card>
							</v-dialog>
						</v-avatar>
					</v-col>

					<!-- Profile Info -->
					<v-col class="pl-4">
						<!-- Name + icons -->
						<div class="d-flex align-center">
						<span class="font-weight-bold text-h6">
							{{profileData?.first_name}} {{profileData?.last_name}}
						</span>

						<!-- Edit -->
						<v-dialog v-model="dialog" width="500" persistent>
							<template v-slot:activator="{ on, attrs }">
							<v-btn class="pl-2" icon small v-bind="attrs" v-on="on">
								<v-icon medium class="grey--text">mdi-pencil-plus-outline</v-icon>
							</v-btn>
							</template>
							<v-card>
							<v-card-title class="text-h5 grey lighten-2">
								Update Profile image and description
							</v-card-title>
							<v-file-input
								accept="image/png, image/jpeg, image/bmp"
								prepend-icon="mdi-camera"
								label="Upload Profile Pic"
								v-model="uploadFile"
								class="px-4"
							/>
							<v-textarea
								outlined
								placeholder="Update profile description here."
								v-model="description"
								class="px-4"
							/>
							<v-text-field
								label="Website Link Here"
								v-model="websiteLink"
								solo
								class="px-4"
							/>
							<v-divider></v-divider>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn
								color="primary"
								text
								@click="handleUpdateProfile"
								:disabled="isLoading"
								>
								Save
								</v-btn>
								<v-snackbar
								v-model="snackbar"
								:timeout="timeout"
								shaped
								color="success"
								>
								Profile Successfully Updated
								</v-snackbar>
								<v-btn color="blue darken-1" text @click="dialog = false">
								Close
								</v-btn>
							</v-card-actions>
							</v-card>
						</v-dialog>

						<!-- Donation -->
						<v-dialog v-model="donationDialog" width="400" persistent>
							<template v-slot:activator="{ on, attrs }">
							<v-btn icon medium v-bind="attrs" v-on="on">
								<v-icon large class="grey--text">mdi-cash</v-icon>
							</v-btn>
							</template>
							<v-card>
							<donationLink @close-dialog="donationDialog = false" />
							</v-card>
						</v-dialog>
						</div>

						<!-- Description -->
						<div class="text-body-2 mt-2">
						{{ profileData?.profile.description }}
						</div>

						<!-- Website -->
						 
						<div class="mt-1">
						<a :href="profileData?.profile.website_link" target="_blank">
							{{ profileData?.profile.website_link }}
						</a>
						</div>
					</v-col>

					<!-- Follow button fixed right -->
					<v-col cols="auto" class="d-flex justify-end">
						<v-btn color="primary" outlined>FOLLOW</v-btn>
					</v-col>
					</v-row>

					<!-- Stats section -->
					<v-divider class="my-4"></v-divider>
					<v-row align="center" justify="space-around">
					<v-col cols="4" class="text-center">
						<h3 class="red--text font-weight-bold">0</h3>
						<span class="grey--text">Following</span>
					</v-col>
					<v-divider vertical></v-divider>
					<v-col cols="4" class="text-center">
						<h3 class="red--text font-weight-bold">0</h3>
						<span class="grey--text">Likes</span>
					</v-col>
					<v-divider vertical></v-divider>
					<v-col cols="4" class="text-center">
						<h3 class="red--text font-weight-bold">0</h3>
						<span class="grey--text">Posts</span>
					</v-col>
					</v-row>
				</v-card>
			</section>	
			<section class="section2 pt-3 clearfix">
				<div class="row2tab clearfix">
					<v-tabs v-model="tab" color="deep-purple-accent-4" align-tabs="center" class="elevation-6" show-arrows>
						<v-tab><v-icon color="red">mdi-radiobox-marked</v-icon>Pings </v-tab>
						<v-tab><v-icon color="primary">mdi-hard-hat</v-icon>Projects</v-tab>
						<v-tab><v-icon color="primary">mdi-flashlight</v-icon>Spotlight </v-tab> 
						<v-tab><v-icon color="primary">mdi-calendar-check</v-icon>Task </v-tab> 
						<v-tab><v-icon color="primary">mdi-selection-marker</v-icon>Reping </v-tab> 
						<!--First Tab-->
						<v-tab-item class="pb-8">
							<v-row class="pt-2 pl-2 pr-2 pb-5">
								<profilePost v-for="post in sortedPosts" :key="post.id" :post="post"
									@update-post-event="handleUpdatePost" @delete-post-event="handleDeletePost" />
							</v-row>
						</v-tab-item>
						<!--Second Tab -->
						<v-tab-item>
							<div class="pa-3">
								Nebucanazzar: Ship Building Project
								<v-progress-linear v-model="power" color="amber" height="25">
									<template v-slot:default="{ value }">
										<strong>{{ Math.ceil(value) }}%</strong>
									</template>
								</v-progress-linear>
								<br>
								Sirius Technology: Space Technology
								<v-progress-linear v-model="skill" color="blue-grey" height="25">
									<template v-slot:default="{ value }">
										<strong>{{ Math.ceil(value) }}%</strong>
									</template>
								</v-progress-linear>
								<br>
								Sawlid: Heavy Mechanics Technology
								<v-progress-linear v-model="knowledge" height="25">
									<strong>{{ Math.ceil(knowledge) }}%</strong>
								</v-progress-linear>
							</div>
						</v-tab-item>
						<v-tab-item class="pb-8">
							<!--Third tab-->
							<v-row class="pt-2 pl-2 pr-2">
								<v-col
									v-for="n in 3"
									:key="n"
									cols="12"
									sm="6"
									md="4"
									>
									<spotlight :key="n" @open-event-menu="openEventMenu" @open-scheduled-event="openScheduledEvent" />
								</v-col>
							</v-row>
						</v-tab-item>
						<!--Fourth tab-->
						<v-tab-item class="pb-15">
							<v-text-field v-model="newTask" label="Type a task and enter to Create a task." solo
								@keydown.enter="create">
								<template v-slot:append>
									<v-fade-transition>
										<v-icon v-if="newTask" @click="create">
											mdi-plus-circle
										</v-icon>
									</v-fade-transition>
								</template>
							</v-text-field>
							<h2 class="text-h4 success--text pl-4">
								Tasks:&nbsp;
								<v-fade-transition leave-absolute>
									<span :key="`tasks-${tasks.length}`">
										{{ tasks.length }} (example)
									</span>
								</v-fade-transition>
							</h2>
							<v-divider class="mt-4"></v-divider>
							<v-row class="my-1" align="center">
								<strong class="mx-4 info--text text--darken-2">
									Remaining: {{ remainingTasks }}
								</strong>

								<v-divider vertical></v-divider>

								<strong class="mx-4 success--text text--darken-2">
									Completed: {{ completedTasks }}
								</strong>
								<v-progress-circular :value="progress" class="mr-2" color="red"></v-progress-circular>
							</v-row>
							<v-divider class="mb-4"></v-divider>
							<v-card v-if="tasks.length > 0">
								<v-slide-y-transition class="py-0" group tag="v-list">
									<template v-for="(task, i) in tasks">
										<div v-if="i !== -1" :key="i">
											<v-divider></v-divider>
											<v-list-item>
												<v-list-item-action>
													<v-checkbox v-model="task.done"
														:color="task.done && 'grey' || 'primary'">
														<template v-slot:label>
															<div :class="task.done && 'grey--text' || 'primary--text'"
																class="ml-4" v-text="task.text"></div>
														</template>
													</v-checkbox>
												</v-list-item-action>
												<v-spacer></v-spacer>
												<v-scroll-x-transition>
													<v-icon v-if="task.done" color="success">
														mdi-check
													</v-icon>
												</v-scroll-x-transition>
											</v-list-item>
										</div>

									</template>
								</v-slide-y-transition>
							</v-card>
						</v-tab-item>
						<!--Fifth Tab-->
						<v-tab-item>
							<v-row class="pt-2 pl-2 pr-2 pb-2">
								<profileReping v-for="item in repostsData" :key="item.id" :post="item.post"/>							
							</v-row>
						</v-tab-item>
					</v-tabs>
				</div>
			</section>
		</div>
	</v-sheet>
	<v-sheet v-else :width="profilePageWidth" :height="profilePageHeight" class="overflow-auto pb-10" >
		<div class="container pb-10">
			<section class="section1">
				<v-card class="pa-3" outlined>
					<v-row no-gutters align="start">
					<!-- Avatar -->
					<v-col cols="auto" class="pr-2">
						<v-avatar size="50">
							<v-img v-if="!profileData?.profile.profile_image">
								<v-icon>mdi-camera</v-icon>
							</v-img>
							<v-img  v-else :src="profileData?.profile.profile_image" alt="avatar" @click="imgDialog = true"/>
							<v-dialog 
								:fullscreen="$vuetify.breakpoint.smAndDown"
								:width="$vuetify.breakpoint.mdAndUp ? 800 : '100%'"
								:height="$vuetify.breakpoint.mdAndUp ? 400 : 'mx-auto'" 
								transition="fade-transition"
								v-model="imgDialog" persistent>
								<v-card>
									<v-img  
										:lazy-src="profileData?.profile.profile_image" :src="profileData?.profile.profile_image">
										<v-btn elevation="0" fab x-small outlined color="white" class="close-button float-right" @click="imgDialog = false">
											<v-icon color="white">mdi-close</v-icon>
										</v-btn>
									</v-img>
								</v-card>
							</v-dialog>
						</v-avatar>
					</v-col>

					<!-- Name, description, website -->
					<v-col>
						<!-- Name + icons -->
						<div class="d-flex align-center">
						<span class="font-weight-bold text-subtitle-1">
							{{ profileData?.first_name }} {{ profileData?.last_name }}						
						</span>

						<!-- Edit -->
						<v-dialog v-model="dialog" persistent>
							<template v-slot:activator="{ on, attrs }">
							<v-btn icon medium v-bind="attrs" v-on="on">
								<v-icon medium class="grey--text">mdi-pencil-plus-outline</v-icon>
							</v-btn>
							</template> 
							<v-card  class="pa-2" fullscreen>
								<v-card-title class="text-h5 blue lighten-2 white--text">
									Update Profile
								</v-card-title>
								<v-file-input
									accept="image/png, image/jpeg, image/bmp"
									prepend-icon="mdi-camera"
									label="Upload Profile Pic"
									v-model="uploadFile"
								/>
								<v-textarea
									outlined
									placeholder="Update profile description here."
									v-model="description"
								/>
								<v-text-field
									label="Website Link Here"
									v-model="websiteLink"
									solo
								/>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn
									color="primary"
									text
									@click="handleUpdateProfile"
									:disabled="isLoading"
									>
									Save
									</v-btn>
									<v-snackbar
									v-model="snackbar"
									:timeout="timeout"
									shaped
									color="success"
									>
									Profile Successfully Updated
									</v-snackbar>
									<v-btn color="blue darken-1" text @click="dialog = false">
									Close
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>

						<!-- Donation -->
						<v-dialog v-model="donationDialog" :fullscreen="$vuetify.breakpoint.smAndDown" persistent>
							<template v-slot:activator="{ on, attrs }">
							<v-btn icon small v-bind="attrs" v-on="on">
								<v-icon large class="grey--text">mdi-cash</v-icon>
							</v-btn>
							</template>
							<v-card>
							<donationLink @close-dialog="donationDialog = false"  />
							</v-card>
						</v-dialog>
						</div>

						<!-- Description -->
						<div class="text-body-2 mt-1">
						{{ profileData?.profile.description }}
						</div>

						<!-- Website -->
						<div class="mt-1">
						<a :href="profileData?.profile.website_link" target="_blank">
							{{ profileData?.profile.website_link }}
						</a>
						</div>
					</v-col>

					<!-- Follow button fixed to the right -->
					<v-col cols="auto" class="d-flex justify-end">
						<v-btn color="primary" outlined small>FOLLOW</v-btn>
					</v-col>
					</v-row>

					<!-- Stats section -->
					<v-divider class="my-3"></v-divider>
					<v-row justify="space-around" align="center" class="grey--text text--darken-">
						<v-col cols="4" class="text-center">
							<h3>0</h3>
							<span>Following</span>
						</v-col>
						<v-col cols="4" class="text-center">
							<h3>0</h3>
							<span>Likes</span>
						</v-col>
						<v-col cols="4" class="text-center">
							<h3>0</h3>
							<span>Posts</span>
						</v-col>
					</v-row>
				</v-card>
			</section>
			<section class="section2 pt-3">
				<div class="row2tab">
					<v-tabs v-model="tab" color="deep-purple-accent-4" class="elevation-6">
						<v-tab><v-icon color="red">mdi-radiobox-marked</v-icon>Pings </v-tab>
						<v-tab><v-icon color="primary">mdi-hard-hat</v-icon>Projects</v-tab>
						<v-tab><v-icon color="primary">mdi-flashlight</v-icon>Spotlight </v-tab> 
						<v-tab><v-icon color="primary">mdi-calendar-check</v-icon>Task </v-tab> 
						<v-tab><v-icon color="primary">mdi-selection-marker</v-icon>Reping </v-tab> 
					</v-tabs>
					<v-tabs-items v-model="tab">
						<!--First Tab-->
						<v-tab-item>
							<v-row class="pt-2 pb-2">
								<profilePost v-for="post in sortedPosts" :key="post.id" :post="post"
									@update-post-event="handleUpdatePost" @delete-post-event="handleDeletePost" />
							</v-row>
						</v-tab-item>
						<!--Second Tab -->
						<v-tab-item>
							<div class="pa-3">
								Nebucanazzar: Ship Building Project
								<v-progress-linear v-model="power" color="amber" height="25">
									<template v-slot:default="{ value }">
										<strong>{{ Math.ceil(value) }}%</strong>
									</template>
								</v-progress-linear>
								<br>
								Sirius Technology: Space Technology
								<v-progress-linear v-model="skill" color="blue-grey" height="25">
									<template v-slot:default="{ value }">
										<strong>{{ Math.ceil(value) }}%</strong>
									</template>
								</v-progress-linear>
								<br>
								Sawlid: Heavy Mechanics Technology
								<v-progress-linear v-model="knowledge" height="25">
									<strong>{{ Math.ceil(knowledge) }}%</strong>
								</v-progress-linear>
							</div>
						</v-tab-item>
						<v-tab-item>
							<!--Third tab-->
							<spotlight style="display: block; margin-bottom: 8px; border-bottom: 1px solid #ccc;" v-for="n in 3" :key="n" @open-event-menu="openEventMenu" @open-scheduled-event="openScheduledEvent" />
						</v-tab-item>
						<!--Fourth tab-->
						<v-tab-item>
							<v-text-field v-model="newTask" label="Type a task and enter to Create a task." solo
								@keydown.enter="create">
								<template v-slot:append>
									<v-fade-transition>
										<v-icon v-if="newTask" @click="create">
											mdi-plus-circle
										</v-icon>
									</v-fade-transition>
								</template>
							</v-text-field>
							<h2 class="text-h4 success--text pl-4">
								Tasks:&nbsp;
								<v-fade-transition leave-absolute>
									<span :key="`tasks-${tasks.length}`">
										{{ tasks.length }} (example)
									</span>
								</v-fade-transition>
							</h2>
							<v-divider class="mt-4"></v-divider>
							<v-row class="my-1" align="center">
								<strong class="mx-4 info--text text--darken-2">
									Remaining: {{ remainingTasks }}
								</strong>

								<v-divider vertical></v-divider>

								<strong class="mx-4 success--text text--darken-2">
									Completed: {{ completedTasks }}
								</strong>
								<v-progress-circular :value="progress" class="mr-2" color="red"></v-progress-circular>
							</v-row>
							<v-divider class="mb-4"></v-divider>
							<v-card v-if="tasks.length > 0">
								<v-slide-y-transition class="py-0" group tag="v-list">
									<template v-for="(task, i) in tasks">
										<div v-if="i !== -1" :key="i">
											<v-divider></v-divider>
											<v-list-item>
												<v-list-item-action>
													<v-checkbox v-model="task.done"
														:color="task.done && 'grey' || 'primary'">
														<template v-slot:label>
															<div :class="task.done && 'grey--text' || 'primary--text'"
																class="ml-4" v-text="task.text"></div>
														</template>
													</v-checkbox>
												</v-list-item-action>
												<v-spacer></v-spacer>
												<v-scroll-x-transition>
													<v-icon v-if="task.done" color="success">
														mdi-check
													</v-icon>
												</v-scroll-x-transition>
											</v-list-item>
										</div>

									</template>
								</v-slide-y-transition>
							</v-card>
						</v-tab-item>
						<!--Fifth Tab-->
						<v-tab-item>
							<v-row class="pt-2 pl-2 pr-2 pb-2">
								<profileReping v-for="item in repostsData" :key="item.id" :post="item.post"/>
							</v-row>
						</v-tab-item>
					</v-tabs-items>
				</div>
			</section>
		</div>
	</v-sheet>
</template>
<!------------------------------>
<!--End of sheet profile-->

<script>
import countries from '../countries'
import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import profilePost from './profilePost'
import postDetails from './postDetails'
import donationLink from './donationLink'
import profileReping from './profileReping'
import spotlight from './spotlight'
import { apiUrl } from '../config'

export default {
	data: () => ({
		// Some variables are for the "My Projects feature"
		repostsData: [],
		profilePostData: [],
		imgDialog: false,
		API_URL: apiUrl,
		props: "",
		tab: "",
		profileData: null,
		snackbar: false,
		timeout: 3000,
		skill: 20,
		alertDialog: false,
		dialog: false,
		donationDialog: false,
		knowledge: 33,
		power: 78,
		loading: false,
		isLoading: false,
		countries: [],
		//uploadLocation: "",
		editPost: false,

		// For "Task" feature (not implemented as yet)
		tasks: [
			{
				done: false,
				text: 'Orientation',
			},
			{
				done: false,
				text: 'Step 1: Introduction to Company norms',
			},
			{
				done: false,
				text: 'Step 2: What we expect from participants',
			},
			{
				done: false,
				text: 'Step 3: How to participate effectively',
			},
			{
				done: false,
				text: 'Step 4: Final thoughts',
			},
		],
		newTask: null,
		sheet: false,
		message4: '',
		isHovering: false,
		focus: '',
		type: 'month',
		typeToLabel: {
			month: 'Month',
			week: 'Week',
			day: 'Day',
			'4day': '4 Days',
		},
		selectedEvent: {},
		selectedElement: null,
		selectedOpen: false,
		events: [],
		colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
		names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
		uploadFile: null,
		description: "",
		websiteLink: "",
		// For "spotlight" feature	
		event: {
        title: 'The AES: Currency, Indigenous Army, Where to Next?',

        startText: 'Starts in 1d 34 mins...',

        image: require('@/assets/prof1.jpg'),

        waitingCount: 20000,

        attendees: [
          {
            id: 1,
            name: 'Paula',
            avatar: require('@/assets/prof2.jpg')
          },
          {
            id: 2,
            name: 'User 2',
            avatar: require('@/assets/prof3.jpg')
          },
          {
            id: 3,
            name: 'User 3',
            avatar: require('@/assets/prof4.jpg')
          }
        ]
      },

      eventHost: {
        name: 'Host',
        label: 'Host',
        avatar: require('@/assets/prof5.jpg'),
        online: true
      }
	}),
	watch: {
		userId: {
			immediate: true,
			handler() {
				if (this.userId) {
					this.getProfileData()
					this.getProfilePost()
				}
			}
		}
	},
	components: {
		profilePost,
		profileReping,
		donationLink,
		postDetails,
		spotlight
	},
	props: {
		// Past article fuction as array from Globe.vue
		//
		articles: Array,
		userId: {
			type: String,
			required: true
		},
	},
	methods: {
		// spotlight methods
		openEventMenu() {
			console.log('Event menu clicked')
		},

		openScheduledEvent() {
			console.log('Scheduled event clicked')
		},
		// Get profile post
		async getProfilePost() {
			try {
				// fetch profile post
				let user = localStorage.getItem('user');
				user = JSON.parse(user);

				const authToken = 'Bearer ' + user['access'];

				console.log(authToken)

				const response = await axios.get(`${this.API_URL}users/current-user/`, {
				headers: {
					'Authorization': authToken,
				},
				})
				// set the data returned as profile
				this.profilePostData = response.data;
				this.profile_image = this.profilePostData?.profile.profile_image;
				console.log("Profile post data:", this.profilePostData);

			} catch (error) {
				// log the error
				console.log(error);
			}
			},
		//Get profile Data from API
		async getProfileData() {
			try {
				let user = localStorage.getItem('user');
				user = JSON.parse(user);

				const token = user.access;

				const payload = JSON.parse(atob(token.split('.')[1]));

				const userId = payload.user_id;
				const response = await axios.get(
				`${this.API_URL}posts/users/${userId}/`,
				{
					headers: {
					Authorization: 'Bearer ' + JSON.parse(
						localStorage.getItem('user')
					).access
					}
				})
				this.profileData = response.data
				console.log("Profile data:", this.profileData);
			} catch (error) {
				console.error('Error loading profile:', error)
			}
		},
		//Fetch Reposts
		//
		async fetchReposts() {
			try {
				const storedUser = JSON.parse(localStorage.getItem('user'));
				const token = storedUser.access;

				const response = await axios.get(
					`${this.API_URL}posts/reposts/`,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						}
					}
				);
				this.repostsData = response.data;

				console.log("Here are the reposts:");
				console.log(this.repostsData);
				
			} catch (error) {
				console.error(
					'Error getting reposts:',
					error.response?.data || error
				);
			}
		},
		// Handle delete post function
		//
		async handleDeletePost(postId) {
			console.log('post id from profile page handle delete', postId)
			const isSuccess = await this.deletePostFunc(postId)
			if (isSuccess) {
				await this.getProfileData()
			}
		},
		// Sync delete post function
		//
		async deletePostFunc(postId) {

			try {
				let user = localStorage.getItem('user')
				user = JSON.parse(user)

				const authToken = 'Bearer ' + user['access'];

				console.log(authToken)


				const response = await axios.delete(`${this.API_URL}posts/${postId}/`, {
					headers: {
						'Authorization': authToken,

					},
				})

				console.log(response)
				if (response.status === 204) {
					return true; // Success
				} else {
					console.error('Unexpected status code:', response.status);
					return false; // Not successful
				}
			} catch (error) {
				console.error('Error creating business idea:', error);
				return false; // Failure
			}


		},
		// Handle Updated post function
		//
		async handleUpdatePost(postId, postData) {
			console.log('post id from profile page', postId)
			const isSuccess = await this.updatePostFunc(postId, postData)
			if (isSuccess) {
				await this.getProfileData()
			}
		},
		// Update post function.
		//
		async updatePostFunc(postId, formData) {
			try {
				console.log(formData)
				let user = localStorage.getItem('user')
				user = JSON.parse(user)

				const authToken = 'Bearer ' + user['access'];

				console.log(authToken)


				const response = await axios.patch(`${this.API_URL}posts/${postId}/`, formData, {
					headers: {
						'Authorization': authToken,
						'Content-Type': 'multipart/form-data'
					},
				})

				console.log(response)

				if (response.status === 200) {
					return true; // Success
				} else {
					console.error('Unexpected status code:', response.status);
					return false; // Not successful
				}
			} catch (error) {
				console.error('Error creating business idea:', error);
				return false; // Failure
			}


		},
		// Sync profile function
		//
		async updateProfileFunc(formData) {
			try {
				this.isLoading = true
				console.log(formData)
				let user = localStorage.getItem('user')
				user = JSON.parse(user)

				const authToken = 'Bearer ' + user['access'];

				console.log(authToken)

				const response = await axios.put(`${this.API_URL}users/update-profile/`, formData, {
					headers: {
						'Authorization': authToken,
						'Content-Type': 'multipart/form-data'
					},
				})

				console.log('API Response:', response);


				if (response.status === 200) {
					return true; // Success
				} else {
					console.error('Unexpected status code:', response.status);
					return false; // Not successful
				}
			} catch (error) {
				console.error('Error creating business idea:', error);
				return false; // Failure
			}



		},
		// Update profile function
		//
		async handleUpdateProfile() {
			console.log('save button pressed')
			this.isLoading = false
			if (this.uploadFile || this.description || this.websiteLink) {
				const profileData = {
					description: this.description,
					website_link: this.websiteLink,
					profile_image: this.uploadFile
				}

				console.log('profileData from profilePage', profileData)

				const formData = new FormData();
				formData.append('description', this.description);
				formData.append('website_link', this.websiteLink);

				if (this.uploadFile !== null) {
					formData.append('profile_image', this.uploadFile);

				}

				this.isLoading = true

				const isSuccess = await this.updateProfileFunc(formData)
				this.isLoading = false

				this.snackbar = true
				this.dialog = false

				if (isSuccess) {
					await this.getProfileData()

					this.$emit('fetch-user-data');
				}

			}
		},
		reserve() { },
		// get profile data feature.
		//
		/*
		async getProfileData() {
			try {
				const storedUser = JSON.parse(localStorage.getItem('user'));
				const authToken = 'Bearer ' + storedUser.access;

				// Get the profile ID from the URL
				const userId = this.userId;

				console.log("Profile user ID:", userId);

				const response = await axios.get(
					`${this.API_URL}users/${userId}/`,
					{
						headers: {
						Authorization: authToken
						}
					}
				);

				console.log("Profile response:", response.data);

				this.profileData = response.data;

				this.description = this.profileData.profile.description;
				this.websiteLink = this.profileData.profile.website_link;

				} catch (error) {
					console.error(
					"Error getting profile:",
					error.response?.data || error
				);
			}
		},
		*/
		// Create a task in profile page
		create() {
			this.tasks.push({
				done: false,
				text: this.newTask,
			});

			this.newTask = null
		}
	},
	created() {
		this.getProfileData(),
		this.fetchReposts()
	},
	mounted() {
		this.countries = countries
		this.getProfileData()
	},
	computed: {
		sortedPosts() {
			// Handle if profileData or posts is undefined/null
			if (!this.profilePostData || !this.profilePostData.posts) return [];

			// Sort by date (newest first for example)
			return this.profilePostData.posts.slice().sort((a, b) => {
			return new Date(b.created_at) - new Date(a.created_at);
			});
		},
		// Profile page dimension based on screen size
		//
		profilePageHeight() {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs': return 800;
				case 'sm': return 800;
				case 'md': return 800;
				case 'lg': return 800;
				case 'xl': return 1600;
				default: return 800; // Default value if no case matches
			}
		},
		profilePageWidth() {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs': return 400;
				case 'sm': return 400;
				case 'md': return 1200;
				case 'lg': return 1200;
				case 'xl': return 1800;
				default: return 1200; // Default value if no case matches
			}
		},
		// Planner 
		//
		//this.$refs.calendar.checkChange(),
		...mapState(['user']),
		...mapGetters({ user: "auth/user" }),

		// Task computed methods
		//
		completedTasks() {
			return this.tasks.filter(task => task.done).length
		},
		progress() { 
			return this.completedTasks / this.tasks.length * 100
		},
		remainingTasks() {
			return this.tasks.length - this.completedTasks
		},

	},
}
</script>